
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-spaces",
      function () {
        return require("private-next-pages/study-spaces.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-spaces"])
      });
    }
  